import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Constants } from 'app/shared/constant/constants';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import { WsfxBankDetails } from 'app/shared/constant/wsfx-bank-details';
import { ToastrService } from 'ngx-toastr';
import { UpdatePaymentDetailsRequestModel } from '../../models/order.model';
import { OrderService } from '../../services/order.service';
import { PurposeList } from 'app/shared/constant/purpose-list';
import { QuotationCurrencyItem, RequestQuotationModel} from 'app/modules/dashboard/models/quotation.models';
import { StepperDataModel } from 'app/modules/email-link/models/stepperdata.model';
import  moment from 'moment';
import { UpdateProfileService } from 'app/modules/update-profile/services/update-profile.service';
import { RequestAadhaarEsignDetail, RequestAadhaarEsignDetailOrder } from 'app/modules/remittance/models/cart.model';
import { RemittanceService } from 'app/modules/remittance/services/remittance.service';
import { DomSanitizer } from '@angular/platform-browser';
import { EsignMode } from 'app/shared/constant/esign-mode';
import { CardService } from 'app/modules/card/services/card.service';
import { error } from 'console';

@Component({
  selector: 'order-details',
  templateUrl: './order-details.component.html',
  styleUrls: [
    './order-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OrderDetailsComponent implements OnInit {
  public orderRating: any;
  public orderID: any;
  public date: any;
  public time: any;
  public orderDetails: any;
  public showLoader: boolean = true;
  public paymentItemList = Constants.paymentItemList;
  public modalReference: any;
  public documentUrl: any;
  public documentTitle: any;
  public a2FormUrl: any;

  public startDate: NgbDateStruct;
  public readOnlyRating: boolean = true;
  public isSurrenderOrder: boolean = false;

  public documentListResponse: any;
  public transactionDocListAwaiting: any;
  public transactionDocListUploaded: any;
  public skipDocumentUpload: boolean = false;
  public documenturl: any;

  public manualPaymentType: any;
  public accountName = WsfxBankDetails.ACCOUNT_NAME;
  public bankName = WsfxBankDetails.BANK_NAME;
  public accountNo = WsfxBankDetails.ACCOUNT_NUMBER;
  public bankIFSC = WsfxBankDetails.BANK_IFSC;
  public bankBranch = WsfxBankDetails.BANK_BRANCH;
  public selectedPurposeItem: any;
  public paymentDate: any;
  public transactionPaymentDate : any;
  public docType: any;
  public transactionProof: any;

  public updatePaymentDetailsRequestModel = new UpdatePaymentDetailsRequestModel();
  public quotationCurrencyItem: QuotationCurrencyItem = new QuotationCurrencyItem();
  public requestQuotationModel: RequestQuotationModel = new RequestQuotationModel();
  public stepperDataModel: StepperDataModel = new StepperDataModel();
  public readOnlyAmount: boolean = false;
  public transactionDetails: any;
  public forexMarginString: String = '0.00';
  public showCheckedMark: boolean = false;

  public showUploadPaymentProof: boolean = false;
  public showUploadPaymentProofRightSection: boolean = false;
  public showTransactionPaymentForm: boolean = false;
  public transactionPaymentStatus: boolean = false;
  public resGetVcipStatus: any;
  public consumerId :any;
  public transactionDetailsMaxDate : any;
  public transactionID :any;
  public showCheckMarkForPaymentProof : boolean = false;
  public hideBeneficiaryDetails  : boolean = true;
  public showBeneDetails  : boolean = false;
  
  public  moment: any = moment;
  public transaction: any;
  public consumerDetail: any;
  public isVcipComplete: boolean = false;
  @ViewChild('vcipCompleteAfterOrder') vcipCompleteAfterOrder: TemplateRef<any>;
  vkycTimingText: string;
  active : any;
  orderPurposeCode: string;
  idfcSignedForm:string = '';
  isRequiredDocumentPending: boolean = true;
  public showESignIframe: boolean = false;  
  public esignResp: any;
  public esignUrl: any;
  public url: any;
  public signatureMode = EsignMode.activeEsignMode;
  public esignA2FormURL: string;
  public allCard = Constants.cardData;
  public cardOrderType;
  public isShowA2FormFile: boolean = false;
  public a2FormProcess: boolean = false;
  public shipmentData:any;
  public shipmentScans: any;
  public isDeliveryStatusAvaliable:boolean = false;

  public isShipmetDelivered: boolean = false;
  public shipmentDeliveredData;
  public isShipmentOutForDelivery: boolean = false;
  public shipmentOutForDeliveryData;
  public isInTransit: boolean = false;
  public shipmentInTransitData;
  public isShipmentPickedUp = false;
  public shipmentPickedUpData;
  public encashmentProduct;
  public isAD1Flow: string = "AD2";  
  public isXplorerCardOrder: boolean = false;
  public xplorerInvoiceDetails;
    
  constructor(
    public orderService: OrderService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    public router: Router,
    public toast: ToastrService,
    public updateProfileService : UpdateProfileService,
    public remittanceService: RemittanceService,
    public sanitizer: DomSanitizer,
    public cardService: CardService
  ) {
    this.consumerId = localStorage.getItem(ConstantsKey.CONSUMER_ID);
    this.orderID = this.route.snapshot.paramMap.get('orderID');
    this.getSingleOrderDetails();
    // this.getTransactionDetails();
    this.getProfileDetails();
    // this.downloadA2Form();
    this.getOrderDocumentsList();

  }

  ngOnInit(): void {
    this.vkycTimingText= Constants.vkycTimingText;
    this.transactionDetailsMaxDate = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() };


    let configData:any = localStorage.getItem(ConstantsKey.CONFIG_CORE_DATA);
    if(configData) {
      configData = JSON.parse(configData);
      configData = configData.filter(data => data.key == 'flow_family_maintenance');
      if(configData.length == 1) {
        this.isAD1Flow = (configData)[0].value;
        sessionStorage.setItem(ConstantsKey.IS_AD1_FLOW, this.isAD1Flow);
      } else {
        sessionStorage.setItem(ConstantsKey.IS_AD1_FLOW, "AD2");
      }
    }    

   }

  goToOrderRatingPage() {
    this.router.navigate(['/ratings', this.orderID]);
  }

  getSingleOrderDetails() {
    this.showLoader = true;
    this.orderService.getOrderDetailsSingle(this.orderID).subscribe(resp => {
      this.showLoader = false;
      this.orderDetails = resp.body;
      if(this.orderDetails?.orderType?.includes('REMITTANCE')){
        this.hideBeneficiaryDetails = false;
        this.orderPurposeCode = this.orderDetails["orderItems"][0].purpose;
      }

      
      if(this.orderDetails.orderType == 'BUY_CARD') {
        if(this.orderDetails?.invoice?.xplorerCardDetails) {
          this.isXplorerCardOrder = true;
          this.xplorerInvoiceDetails = this.orderDetails?.invoice?.xplorerCardDetails;
        }
        this.getShipmentTrack();
      }


      if(this.orderDetails?.orderStatusGroup?.a2Form == 'SIGNED') {
          this.downloadA2Form();
      }
      if(this.orderDetails?.productGroup == 'REMITTANCE' && this.orderDetails?.orderStatusGroup?.a2Form == 'UNAVAILABLE') {
        this.getDocumentForSignNew(this.orderID);
      }

      if(this.orderDetails["productGroup"] == "FOREX" && (this.orderDetails["orderType"] == "BUY_CARD" || this.orderDetails["orderType"] == "RELOAD_CARD" || this.orderDetails["orderType"] == "CASH_OUT")) {
          let orderItem = this.orderDetails["orderItems"];
          let forexOrder = orderItem.filter(order => order.product == 'FOREXCARD');
          this.cardOrderType = this.allCard.filter(obj => obj.cardVendor == forexOrder[0]["issuerCode"])[0];
      }

      if(this.orderDetails['documents']) {
        let document = this.orderDetails['documents'];
        for (let i= 0; i < document.length; i++) {
          if (document[i]['documentType'] == 'SIGN_IDFC_REMITTANCE_FORM') {
              this.idfcSignedForm = document[i]['location'];
          }
        }
      }


      if (this.orderDetails.orderFeedback.averageRating) {
        this.orderRating = this.orderDetails.orderFeedback.averageRating;
      } else {
        if (this.orderDetails.orderFeedback.onboarding > 0) {
          this.orderRating = (this.orderDetails.orderFeedback.onboarding +
            this.orderDetails.orderFeedback.transaction +
            this.orderDetails.orderFeedback.transparency +
            this.orderDetails.orderFeedback.support +
            this.orderDetails.orderFeedback.overall) / 5;
        } else{
          this.readOnlyRating = false;
        }
      }
      if(this.orderDetails.sellType=='BUY' ){
        this.isSurrenderOrder=true;
        this.hideBeneficiaryDetails=true;
        this.showUploadPaymentProof=false;
        this.encashmentProduct = this.orderDetails.orderItems[0].product;
      }

      this.updatePaymentDetailsRequestModel.amount = this.orderDetails?.invoice?.totalBillAmountString;
      // if (this.updatePaymentDetailsRequestModel.amount != null || this.updatePaymentDetailsRequestModel.amount != "") {
      //   this.readOnlyAmount = true;
      // }
      if (this.orderDetails.paymentMode!='NB') {
        this.readOnlyAmount = false;        

     }
      if (this.orderDetails?.invoice?.marginCharges!=null) {
        this.forexMarginString = this.orderDetails?.invoice?.marginCharges.toFixed(2) + "";
      }
      if (this.orderDetails?.beneficiaryDetails) {
        this.showBeneDetails = true;
      }
      // if (this.orderRating == -1 || this.orderRating == 0) {
      //   this.readOnlyRating = false;
      // }
      console.log("ORDER DETAILS  >>>>>>>>>>", this.orderDetails);
      console.log("PAYMENT STATUS >>>>>>>>>>", this.orderDetails.orderStatusGroup.consumerPayment);
      sessionStorage.setItem(ConstantsKey.ORDER_DETAILS_PAGE_DATA, JSON.stringify(this.orderDetails));
      if (this.orderDetails.orderStatusGroup.consumerPayment == 'COMPLETED') {
        this.showUploadPaymentProof = false;
        this.showTransactionPaymentForm = false;
      } else if ( this.orderDetails.orderStatusGroup.consumerPayment == 'PARTIAL' || (this.orderDetails.paymentMode != 'TPV' && this.orderDetails.orderStatusGroup.consumerPayment != 'COMPLETED')  ) {
        this.showUploadPaymentProof = true;
        // this.showTransactionPaymentForm = true;
      }
      this.getTransactionDetails();
    },
      error => {
        this.showLoader = false;
        this.toast.error(error.error.message);
      });
  }

  openModalForOrder(orderModal) {
    this.modalReference = this.modalService.open(orderModal, { centered: true });
  }

   gotoOrder() {
    this.modalReference.close();
    this.orderService.getOrderDetailsSingle(this.orderID).subscribe(resp => {
      this.showLoader = false;
      this.orderDetails = resp.body;
      console.log("I am here")
      console.log("orderdetails++", this.orderDetails);
    this.selectedPurposeItem = PurposeList.getPurposeObjectByPurposeCodeRemittance(this.orderDetails.orderItems[0].purpose);
        console.log("this.selectedPurposeItem >>", this.selectedPurposeItem);
        //   /// prepare quotation request
        
        let listQuotationCurrencies: Array<QuotationCurrencyItem> = [];
        this.quotationCurrencyItem.currencyCode = this.orderDetails.orderItems[0].currencyCode;
        this.quotationCurrencyItem.currencyAmount = this.orderDetails.orderItems[0].currencyAmount;
        this.quotationCurrencyItem.bidRate = this.orderDetails.orderItems[0].bidRate;
        this.quotationCurrencyItem.product = Constants.productsEnum[2];
        this.quotationCurrencyItem.purpose = (this.selectedPurposeItem?.purposeCode)
          ? this.selectedPurposeItem.purposeCode
          : "UNIVERSITY_FEES";

        listQuotationCurrencies.push(this.quotationCurrencyItem);

        this.requestQuotationModel.sellType = Constants.sellTypes[0];
        this.requestQuotationModel.partnerId = Constants.partnerId;
        this.requestQuotationModel.nostroChargeType = 'REMITTER';
        this.requestQuotationModel.quotationCurrencies = listQuotationCurrencies;

        /// store active order in session storage
        this.stepperDataModel.purposeItem = this.selectedPurposeItem;
        this.stepperDataModel.quotationRequest = this.requestQuotationModel;
        this.stepperDataModel.orderDetails = resp.body;
        console.log("stepper data +++", this.stepperDataModel.orderDetails);

        sessionStorage.setItem(ConstantsKey.SS_ACTIVE_ORDER, JSON.stringify(this.stepperDataModel));
        this.showLoader = false;

        // console.log("respBody.consumer.vcipKycStatus >>", respBody);

        if (!this.orderDetails.consumer.vcipKycStatus) {
          this.router.navigate(['/update-profile']);
        } else if (this.stepperDataModel.purposeItem.remittanceType == "OTHERS") {
          this.router.navigate(['/emailStepper3step']);
        } else {
          this.router.navigate(['/emailStepper'])
        }
      }, error => {
        this.showLoader = false;
        console.log(error);
      });  
   }

  modalOpenForDocumentView(documentOpenModal, documentDetails) {
    this.modalReference = this.modalService.open(documentOpenModal, { centered: true });
    this.documentUrl = documentDetails.location;
    this.documentTitle = documentDetails.documentType;
  }

  getDateFormat(event) {
    let year = event.year;
    let month = event.month <= 9 ? '0' + event.month : event.month;;
    let day = event.day <= 9 ? '0' + event.day : event.day;
    this.paymentDate = year + "-" + month + "-" + day;
  }

  updatePaymentDetails(formData) {
    if (formData == true) {
      this.showLoader = true;
      this.updatePaymentDetailsRequestModel.orderId = this.orderID;
      this.updatePaymentDetailsRequestModel.paymentDate = this.paymentDate;
      this.updatePaymentDetailsRequestModel.consumerId = this.consumerId;
      this.manualPaymentType = this.updatePaymentDetailsRequestModel.manualPaymentType;
      console.log(JSON.stringify(this.updatePaymentDetailsRequestModel));
      this.orderService.updatePaymentDetails(this.updatePaymentDetailsRequestModel).subscribe((resp => {
        this.showLoader = false;
        this.transactionPaymentStatus = true;
        this.showTransactionPaymentForm = false;
        this.toast.success("Payment updated successfully");
        this.getSingleOrderDetails();
        this.getTransactionDetails();
      }), error => {
        this.showLoader = false;
        this.toast.error(error.error.message);
      });
    }
  }

  getTransactionDetails() {
    this.orderService.getTransactionDetailsList(this.orderID).subscribe((resp => {
      this.transactionDetails = JSON.parse(JSON.stringify(resp.body));
      console.log('transactionDetails >>>> ', this.transactionDetails);
      
      this.transaction = this.transactionDetails[0];
      // for (let i = 0; i < this.transactionDetails.length; i++) {
      //   this.transactionDetails[i].transactionDetails.paymentDate = moment(this.transactionDetails[i]?.transactionDetails?.paymentDate).format('LLL');
        
      // }
      this.transactionProof = this.transaction?.proof;
      console.log("transactionProof++", this.transactionProof);
      
      if(this.transactionDetails.length == 0){
        this.showTransactionPaymentForm = true;
      }else{
        this.showTransactionPaymentForm = false;
      }
      
      this.updatePaymentDetailsRequestModel.manualPaymentType = '';
      this.updatePaymentDetailsRequestModel.referenceNumber = '';
    }), error => {
    });
  }

  showProof() {
    window.open(this.transactionProof, "_blank");
    console.log("proof", this.transactionProof);
  }

  showToastMessage() {
    this.toast.error('Please update transaction details first');
  }

  retryPayment() {
    sessionStorage.setItem(ConstantsKey.IS_FROM_RETRY_PAYMENT, 'true');
    sessionStorage.setItem(ConstantsKey.IS_FROM_REMITTANCE_FLOW, 'false');
    sessionStorage.setItem(ConstantsKey.IS_FROM_BUYNEWCARD, 'false');
    sessionStorage.setItem(ConstantsKey.IS_FROM_RELOAD, 'false');
    this.router.navigate(['/retry-payment', this.orderID]);
  }

  showTransactionForm(){
    this.showTransactionPaymentForm = true;
  }
  downloadA2Form(){
   // this.showLoader=true;
    this.orderService.downloadA2Form(this.orderID).subscribe((resp => {
      //this.showLoader=false;

      var response = JSON.parse(JSON.stringify(resp.body));
      this.a2FormUrl=response.downLoadUrl;
      console.log('a2FormDetails >>>> ', response);
      console.log('a2FormUrl >>>> ', this.a2FormUrl);

    
    }), error => {
      //this.showLoader=false;

    });
  }

  fileUploadOrderDocument(event, docType) {
    this.showLoader = true;
   let fileList: FileList = event.target.files;
   if (fileList.length > 0) {
     let file: File = fileList[0];

     if (file.type.indexOf("pdf") >= 0 || file.type.indexOf("image") >= 0) {
       const formData = new FormData();
       formData.append("file", file, file.name);
       formData.append("ownerType", "CONSUMER");
       formData.append("type", docType);
       formData.append("description", "");
       formData.append(
         "ownerId",
         localStorage.getItem(ConstantsKey.CONSUMER_ID)
       );
       formData.append("documentPurpose", "TRANSACTION");

       // if (file.size > 1000000) {
       //   this.toast.error('Please upload a file of up to 1MB only');
       // } else {
       this.orderService.uploadOrderDocument(formData).subscribe(
         (respDoc) => {

           let resp = respDoc.body;
           let documentIds = [resp["id"]];
           let linkDocumentData = {
               "documentIds": documentIds,
               "kycDocumentPurpose": "TRANSACTION"
           };

           this.orderService.linkDocument(linkDocumentData, this.orderID).subscribe(resp => {

           }, err => {
             this.showLoader = false;
             if (err.status == 200) {
               this.toast.success("Document uploaded successfully");

               this.getOrderDocumentsList();
     
             } else {
               this.toast.error(err.error.message);
             }
           });
           
           
         },
         (error) => {
           this.showLoader = false;
           this.toast.error(error.error.message);
         }
       );
     } else {
       this.showLoader = false;
       this.toast.error('Please select a pdf or image file only');
     }
   }
  }
  
  getOrderDocumentsList() {
    this.showLoader = true;
    this.orderService
      .getOrderDocuments(this.orderID)
      .subscribe((respDocList) => {
        this.showLoader = false;

        this.documentListResponse = respDocList.body;
        this.transactionDocListAwaiting =
          this.documentListResponse.documentCategorywiseUploadDetails.TRANSACTION.statusWiseDocuments.AWAITING;
        this.transactionDocListUploaded =
          this.documentListResponse.documentCategorywiseUploadDetails.TRANSACTION.statusWiseDocuments.UPLOADED;
        console.log("transactionDocument++", this.transactionDocListAwaiting);
        var getActiveOrderData = sessionStorage.getItem(
          ConstantsKey.SS_ACTIVE_ORDER_CARD
        );

        this.isRequiredDocumentPending = (this.transactionDocListAwaiting.filter(e => e.required === true).length > 0)

          // this.stepperDataCardModel = JSON.parse(getActiveOrderData);
          // if (this.documentListResponse.skipDocumentUpload) {
          //   this.stepperDataCardModel.kycDocumentUploadStatus = true;
          //   sessionStorage.setItem(
          //     ConstantsKey.SS_ACTIVE_ORDER_CARD,
          //     JSON.stringify(this.stepperDataCardModel)
          //   );
          // }
        
      }),
      (error) => {
        this.showLoader = false;

        this.toast.error(error.error.message);
      };
  }

  fileUploadTransactionProof(event) {
    this.showLoader = true;
    let fileList: FileList = event.target.files;

    if (fileList.length > 0) {
      let file: File = fileList[0];
      if((file.type == 'image/png') || (file.type == 'image/jpg') || (file.type == 'image/jpeg')) {
      if (file.size >= 0) {
        const formData = new FormData();
        formData.append('transactionId', this.transactionID);
        formData.append('file', file, file.name);

        // if (file.size > 1000000) {
        //   this.showLoader = false;
        //   this.toast.error('Please upload a file of up to 1MB only');
        // } else {
          this.orderService.uploadTransactionProof(formData).subscribe((respDoc) => {
            this.showLoader = false;
            this.showCheckMarkForPaymentProof = true;
            this.toast.success("Payment proof uploaded successfully");
            console.log(JSON.stringify(respDoc));
            this.getTransactionDetails();
          }, error => {
            this.showLoader = false;
            this.toast.error(error.error.message);
          });
        
      }
    } else {
      this.toast.error('Please upload image only!!!');
    }
      this.showLoader = false;
    }
  }

  getTransactionID(id){
    this.transactionID = id;
    console.log("this.transactionID >>", this.transactionID);
  }

  initiateVcip() {
   // this.modalReference.close();
    this.updateProfileService.getVCIPRedirectionURL().subscribe((resp => {
      this.showLoader = false;
      var vcipResponse = JSON.parse(JSON.stringify(resp.body));
      let vcipUrl = vcipResponse.mobileAutologinUrl;
      window.open(vcipUrl, '_blank');
    }), error => {
      this.showLoader = false;
      this.toast.error(JSON.stringify(error.error.message));
    });
  }

  
  getProfileDetails() {
    this.updateProfileService.getProfileListAll().subscribe(resp => {
      this.showLoader = false;
      this.consumerDetail = resp.body;
      this.isVcipComplete = this.consumerDetail?.vcipKyc;
       if (this.consumerDetail?.paxResponse?.consumer?.vcipSkipAllowed) {
        this.isVcipComplete = true;
      } else if (this.consumerDetail?.paxResponse?.consumer?.offlineonboarding == '1') {
        this.isVcipComplete = true;
      }
      if(!this.isVcipComplete){
        this.getVCIPStatus();
      } 
    });
  }
   async getVCIPStatus() {
    this.updateProfileService.getVCIPStaus().subscribe((resp => {
      this.showLoader = false;
       this.resGetVcipStatus = resp.body;
      if (this.resGetVcipStatus.vcipStatus == 'ACCEPTED') {
        this.isVcipComplete=true;
      } else {
        //this.modalReference = this.modalService.open(this.vcipCompleteAfterOrder, { size: 'xl', centered: true });
      }
    }), error => {
      this.toast.error(error.error.message);
    });
    return true;
 }
 
 idfcSignedFormFileUpload(event) {
  this.showLoader = true;
  let fileList: FileList = event.target.files;

  if (fileList.length > 0) {
    let file: File = fileList[0];
    if((file.type == 'image/png') || (file.type == 'image/jpg') || (file.type == 'image/jpeg') || (file.type == 'application/pdf')) {
    if (file.size >= 0) {
      const formData = new FormData();
      formData.append('ownerType', "ORDER");
      formData.append('type', "SIGN_IDFC_REMITTANCE_FORM");
      formData.append('description', "");
      formData.append('ownerId', this.orderID);
      formData.append('file', file, file.name);

      // if (file.size > 1000000) {
      //   this.showLoader = false;
      //   this.toast.error('Please upload a file of up to 1MB only');
      // } else {
        this.orderService.uploadOrderDocument(formData).subscribe((respDoc) => {
          
          this.showCheckMarkForPaymentProof = true;
          console.log(JSON.stringify(respDoc));
          let resp = respDoc.body;
          let documentIds = [resp["id"]];
          let linkDocumentData = {
              "documentIds": documentIds,
              "kycDocumentPurpose": "TRANSACTION"
          };

          this.orderService.linkDocument(linkDocumentData, this.orderID).subscribe(resp => {

          }, err => {
            this.showLoader = false;
            if(err.status == 200) {
              this.toast.success("Signed Application Form uploaded successfully");
              this.getSingleOrderDetails();
    
            } else {
              this.toast.error(err.error.message);
            }
          });
        }, err => {
          this.showLoader = false;
          this.toast.error(err.error.message);
        });
      
    }
  } else {
    this.toast.error('Please upload image or pdf only!!!');
  }
    this.showLoader = false;
  }
}

downloadUploadedIdfcSignedForm() {
  window.location.assign(this.idfcSignedForm);
}

    downloadUploadedDoc(documentDetails) {
      this.documentUrl = documentDetails.location;
      window.location.assign(this.documentUrl);
    }


    async getDocumentForSign() {
      this.showLoader = true;
      let requestAadhaarEsignDetail = new RequestAadhaarEsignDetailOrder();
      requestAadhaarEsignDetail.orderId = this.orderID;
      requestAadhaarEsignDetail.initiateAadharSigning = true;
  
      //let issuerCode = this.stepperDataCardModel.quotationRequest.issuerCode;
      if(this.cardOrderType && this.cardOrderType.cardType == 'smartCurrencyCard') {
          requestAadhaarEsignDetail.initiateAadharSigning = false;
      }

       try {
        const respEsign = await this.remittanceService.getAadharSignedDoc(requestAadhaarEsignDetail).toPromise();
        this.esignResp = JSON.parse(JSON.stringify(respEsign.body));
        this.esignUrl = this.esignResp.url;
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.esignUrl);
        this.showLoader = false;
      } catch (error) {
        this.showLoader = false;
      }
    }

    tabChange(event) {
      console.log("TAB CHANGE EVENT ----- ", event);
      if(event.nextId == 8) {
        // this.getDocumentForSign();
        if(this.orderDetails?.orderStatusGroup?.a2Form && this.orderDetails?.orderStatusGroup?.a2Form == 'UNSIGNED') {
          this.getDocumentForSign();
        }
      }
    }


    showIframeForEsign() {
      let isAKCDone = sessionStorage.getItem(ConstantsKey.ORDER_DETAILS_PAGE_ESIGN_ACK);
      if(isAKCDone == "TRUE") {
        /* if(this.orderDetails?.productGroup == 'FOREX' && this.orderDetails?.orderType != 'CASH_PURCHASE' && this.cardOrderType.cardType == 'smartCurrencyCard') {

        } else { */
          this.showESignIframe = true;
        /* } */
      } else {
        this.toast.error("Kindly accept the Terms & conditions");
      }
    }

      async aadharEsignDocumentDetails() {
        this.showLoader = true;
        let requestAadhaarEsignDetail = new RequestAadhaarEsignDetail();
        requestAadhaarEsignDetail.consumerId = localStorage.getItem(ConstantsKey.CONSUMER_ID);
        requestAadhaarEsignDetail.refOrderId = this.orderID;
        this.remittanceService
          .getA2FormSignedDoc(requestAadhaarEsignDetail)
          .subscribe(async (resp) => {
            this.showLoader = false;
            var resAadhaarEsignDetail = JSON.parse(JSON.stringify(resp.body));
            if (resp.status == 200) {
              if (resAadhaarEsignDetail.esignFileUrl && resAadhaarEsignDetail.esignFileUrl != null && resAadhaarEsignDetail.esignFileUrl != "") {
                window.location.reload();
              } else {
                this.toast.error("Please esign document properly.");
              }
            } else {
              this.toast.error("Please esign document properly!");
            }
          }, (err) => {
            this.showLoader = false;
            this.toast.error(err.error.message);
          });
      }

    parentCallbackFormChild($event) {

    }

    A2FormProceed() {
      if(this.orderDetails?.productGroup == 'REMITTANCE' || this.orderDetails?.orderType == 'CASH_PURCHASE' || (this.orderDetails?.productGroup == 'FOREX')) {
        this.showIframeForEsign();
      } else {
        this.otpVerification();
      }
    }

    otpVerification() {
      let otp = sessionStorage.getItem(ConstantsKey.SMART_A2_FORM_OTP);

    if (this.validateStep03(otp)) {
      this.showLoader = true;
      let a2AcceptanceRequest = {
        orderId: this.orderID,
        otp: otp,
      };

      this.cardService.validateA2OTP(a2AcceptanceRequest).subscribe((respDownloadA2) => {
            this.showLoader = false;
            var jsonResult = JSON.parse(JSON.stringify(respDownloadA2.body));
            window.location.reload();
            this.getDocumentForSignNew(this.orderID);
      },(error) => {
            this.showLoader = false;
            this.toast.error(error.error.message);
      });
    }
  }

    validateStep03(otp) {
      let A2_ACK = sessionStorage.getItem(ConstantsKey.ORDER_DETAILS_PAGE_ESIGN_ACK);
      if(A2_ACK == 'FALSE') {
        this.toast.error("Kindly accept the Terms & conditions");
        return false;
      }

      if (!otp) {
        this.toast.error("Please enter the OTP received.");
        return false;
      }
      return true;
    }

    async getDocumentForSignNew(orderIdForSign) {
      this.showLoader = true;
      
      let requestAadhaarEsignDetail = new RequestAadhaarEsignDetailOrder();
      requestAadhaarEsignDetail.orderId = orderIdForSign;
      requestAadhaarEsignDetail.initiateAadharSigning = true;
      
      if(this.cardOrderType && this.cardOrderType.cardType == 'smartCurrencyCard') {
          requestAadhaarEsignDetail.initiateAadharSigning = false;
      }

      try {
        const respEsign = await this.remittanceService.getAadharSignedDoc(requestAadhaarEsignDetail).toPromise();
        this.esignResp = JSON.parse(JSON.stringify(respEsign.body));
        this.esignUrl = this.esignResp.url;
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.esignUrl);
        this.showLoader = false;
      } catch (error) {
        this.showLoader = false;
      }
  }

  downloadEncasmentForm() {
   // let form = this.orderDetails["formUrl"];
  //  let form = this.orderDetails["a2Form"];
  //   window.open(form, "_blank");
    let orderDocument = this.orderDetails.documents;
     let encashmentDocument = orderDocument.filter(obj => obj.documentType == "SIGNED_A2")[0];
     window.open(encashmentDocument.location, "_blank"); 
  }

  downloadReloadForm() {
    let form = this.orderDetails["formUrl"];
    window.open(form, "_blank");
  }

  getShipmentTrack() {
    this.showLoader = true;
    this.orderService.getShipmentDerliveryStatus(this.orderID).subscribe((resp)=> {
      this.showLoader = false;
      this.shipmentData = resp.body;
      console.log("SHIPMENT DATA ------ ", this.shipmentData);

      this.shipmentData?.scans.forEach(item => {
        console.log("SHIPMENT ITEM ---------------------------------- ",item);
        if(item.scan.includes("SHIPMENT PICKED UP")) {
          this.isShipmentPickedUp = true;
          this.shipmentPickedUpData = item;
        } else if(item.scan.includes("IN TRANSIT")) {
          this.isInTransit = true;
          this.shipmentInTransitData = item;
        } else if(item.scan.includes("SHIPMENT OUT FOR DELIVERY")) {
          this.isShipmentOutForDelivery = true;
          this.shipmentOutForDeliveryData = item;
        } else if(item.scan.includes("SHIPMENT DELIVERED")) {
          this.isShipmetDelivered = true;
          this.shipmentDeliveredData = item;
        }
      });
      console.log("SHIPMENT DATA ------ ", this.shipmentData);
      //this.isDeliveryStatusAvaliable = true;

    }, err => {
      this.showLoader = false;
      // this.toast.error(err.error.message);
    })
  }

  downloadOrderForm() {
    let form = this.orderDetails["a2Form"];
    window.open(form, "_blank");
  }

  downloadInvoie() {
    let form = this.orderDetails["extInvoice"];
    window.open(form, "_blank");    
  }
  
}
